// ✅ FILE: src/components/fair-practice-code.js

import React from 'react';
import Table from 'react-bootstrap/Table';
import "./terms-conditions.css";

const FairPracticeCode = () => {
  return (
    <div className="tc-container">
      <header className="tc-header mb-4">
        <h1>Fair Practice Code</h1>
        <p className="text-muted">Our Commitment to Transparency and Ethical Lending</p>
      </header>

      <section className="tc-content mb-3">
        <h2>Introduction</h2>
        <p>
          <b>Singh Finlease Private Limited</b> is a non-deposit taking Non-Banking Finance Company 
          registered with the Reserve Bank of India (“RBI”). The Company is engaged in the business 
          of providing personal loans and other credit facilities to individuals. This Fair Practices 
          Code (“FPC”) has been established as per RBI guidelines to ensure transparency, 
          integrity, and fairness in all our customer dealings.
        </p>

        <h2>1. Key Commitments</h2>
        <p>The Company is committed to the following principles:</p>
        <ul>
          <li>Acting fairly and reasonably in all customer dealings.</li>
          <li>Meeting the commitments and standards specified in this Code.</li>
          <li>Ensuring compliance with applicable laws and regulations.</li>
          <li>Handling grievances fairly and promptly.</li>
          <li>Maintaining total integrity and transparency in all financial operations.</li>
        </ul>

        <h2>2. Information and Transparency</h2>
        <p>
          We assist customers in choosing products that meet their needs by providing clear information 
          regarding key features. Customers are informed about the necessary documentation required 
          for identity and address verification as per the “Know Your Customer” (KYC) guidelines.
        </p>

        <h2>3. Loan Applications and Processing</h2>
        <p>
          Our digital lending platform, <b>Loanonsalary</b>, is designed to make personal financing 
          fast and easy. The entire process—from registration and application to disbursement—is 
          conducted online. 
        </p>
        <ul>
          <li>All communications are provided in English or a language understood by the borrower.</li>
          <li>Loan application forms include all necessary information affecting the interest of the borrower.</li>
          <li>The Company provides a digital acknowledgement for each loan application.</li>
          <li>Applications are processed within a reasonable timeframe. If an application is rejected, the borrower is informed.</li>
        </ul>

        <h2>4. Loan Appraisal and Terms</h2>
        <p>
          Borrowers are informed of the sanctioned amount, interest rate, and terms via SMS or Email. 
          Digital consent is recorded, and all penalty clauses are clearly mentioned in the loan 
          agreement and FAQs.
        </p>

        <h2>5. Interest Rate Model</h2>
        <p>
          Interest rates are determined based on a combination of internal and market-linked factors, including:
        </p>
        <div className="mb-4">
          <Table bordered responsive hover className="mt-3">
            <thead className="table-secondary">
              <tr>
                <th>#</th>
                <th>Cost Factor</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Cost of Borrowing</td>
                <td>Weighted average cost of funds borrowed privately or through institutions.</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Fund Raising Cost</td>
                <td>Includes processing fees and brokerage associated with capital.</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Opex Cost</td>
                <td>Operational expenses including staff, technology, and marketing.</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Risk Premium</td>
                <td>Buffer for credit and default risks associated with the borrower profile.</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Base ROA</td>
                <td>The minimum return on assets expected by the Company.</td>
              </tr>
            </tbody>
          </Table>
        </div>

        <h2>6. General Conduct</h2>
        <ul>
          <li>The Company avoids interference in the private affairs of the borrower except for the purposes provided in the loan agreement.</li>
          <li>No harassment or unethical recovery practices are permitted.</li>
          <li>Loan account transfer requests are processed within 21 days.</li>
        </ul>

        <h2>7. Grievance Redressal Mechanism</h2>
        <p>
          Disputes are resolved through a structured grievance forum. If a complaint is not 
          resolved within one month, the customer may approach the <b>NBFC Ombudsman</b> of the RBI.
        </p>
        <div className="alert alert-secondary">
          <strong>Grievance Redressal Officer:</strong> Jitendra Kumar <br />
          <strong>Address:</strong> A-29, Mangolpuri Industrial Area, Phase - II, Delhi, 110034 <br />
          <strong>Email:</strong> grievance@loanonsalary.com
        </div>

        <h2>8. Schedule of Charges</h2>
        <div className="table-responsive mt-3">
          <Table striped bordered hover>
            <thead className="table-dark">
              <tr>
                <th>Type of Charge</th>
                <th>Details / Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Processing Fee</td>
                <td>Starts from 8 to 15% on principle amount</td>
              </tr>
              <tr>
                <td>Loan Foreclosure</td>
                <td>Nil / Up to 5% + GST for other products</td>
              </tr>
              <tr>
                <td>GST</td>
                <td>18% applicable on Processing Fees</td>
              </tr>
              <tr>
                <td>Rate of Interest</td>
                <td>Up to 365% APR (1% Daily)</td>
              </tr>
              <tr>
                <td>Late Payment Penalty</td>
                <td>2% per day on overdue amount</td>
              </tr>
              <tr>
                <td>Loan Cancellation</td>
                <td>₹0</td>
              </tr>
              <tr>
                <td>Duplicate NOC / Statements</td>
                <td>₹500 + 18% GST</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </section>
    </div>
  );
};

export default FairPracticeCode;